var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIvtgrade(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 624.38 169.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2a5a66;}.cls-1,.cls-2,.cls-3{stroke-width:0px;}.cls-2{fill:#10b0a2;}.cls-3,.cls-4{fill:#ededed;}.cls-5{letter-spacing:0em;}.cls-4{font-family:RalewayRoman-Bold, Raleway;font-size:157.6px;font-variation-settings:'wght' 700;font-weight:700;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(163.1 134.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 114.26,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 174.78,
    y: 0
  }, "ade")), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 33.18 0 138.36 132.73 155.32 132.73 11.13 0 33.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m26.21,68.85v36.77h-8.68v-31.11l8.68-5.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m40.12,61.02l12.08,34.35,11.89-34.35h9.13l-16.87,44.59h-8.37l-16.99-44.59h9.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m115.2,68.62h-14.22v36.99h-8.62v-36.99h-14.35v-7.6h37.19v7.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.2 61.02 106.79 68.62 115.2 68.62 115.2 61.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.21 68.77 17.53 60.93 26.21 60.93 26.21 68.77"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIvtgrade);
export default __webpack_public_path__ + "static/media/logo-ivtgrade.db21f1198a9025408454874fa82bb937.svg";
export { ForwardRef as ReactComponent };